import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './route/App';
import registerServiceWorker from './registerServiceWorker/registerServiceWorker';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js